import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axiosInstance from '../../api/axiosInstance';

const EmailSetting = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [saved, setSaved] = useState(null);

    const [formData, setFormData] = useState({
        SMTP_HOST: '',
        SMTP_PORT: '',
        SMTP_MAIL: '',
        SMTP_PASSWORD: '',
    });

    const fetchSettings = async () => {
        try {
            setLoading(true);
            const res = await axiosInstance.get('getEmailSmtpSettings');
            if (res.data?.success) {
                setFormData(res.data.data);
                setSaved(res.data.data);
            } else {
                Swal.fire("Error", "Failed to fetch Email settings", "error");
            }
        } catch {
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchSettings(); }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCancel = () => {
        setIsEditing(false);
        if (saved) setFormData(saved);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const res = await axiosInstance.put('updateEmailSmtpSettings', formData);
            if (res.data?.success) {
                Swal.fire("Success", "Email settings updated successfully", "success");
                setIsEditing(false);
                fetchSettings();
            } else {
                Swal.fire("Error", "Failed to update Email settings", "error");
            }
        } catch {
            Swal.fire("Error", "Something went wrong during update", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <div className="spinner-border text-primary" />
                    </div>
                ) : (
                    <>
                        <h5>
                            <i className="fa fa-arrow-left me-2" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
                            Email Settings (SMTP)
                        </h5>

                        <div className="card p-4">
                            {!isEditing ? (
                                <>
                                    <div className="d-flex justify-content-end">
                                        <button className="btn btn-primary btn-sm mb-3" onClick={() => setIsEditing(true)}>
                                            <i className="fa fa-edit me-2" />Edit
                                        </button>
                                    </div>
                                    <p><b>SMTP Host:</b> {saved?.SMTP_HOST || <span className="text-muted">—</span>}</p>
                                    <p><b>SMTP Port:</b> {saved?.SMTP_PORT || <span className="text-muted">—</span>}</p>
                                    <p><b>SMTP Mail:</b> {saved?.SMTP_MAIL || <span className="text-muted">—</span>}</p>
                                    <p><b>SMTP Password:</b> {saved?.SMTP_PASSWORD ? "••••••••" : <span className="text-muted">—</span>}</p>
                                </>
                            ) : (
                                <form onSubmit={handleUpdate}>
                                    <div className="mb-3">
                                        <label className="form-label">SMTP Host</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="SMTP_HOST"
                                            value={formData.SMTP_HOST}
                                            onChange={handleChange}
                                            placeholder="e.g. smtp.gmail.com"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">SMTP Port</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="SMTP_PORT"
                                            value={formData.SMTP_PORT}
                                            onChange={handleChange}
                                            placeholder="e.g. 465"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">SMTP Mail</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="SMTP_MAIL"
                                            value={formData.SMTP_MAIL}
                                            onChange={handleChange}
                                            placeholder="your-email@example.com"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">SMTP Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="SMTP_PASSWORD"
                                            value={formData.SMTP_PASSWORD}
                                            onChange={handleChange}
                                            placeholder="••••••••"
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary me-2">Update</button>
                                    <button type="button" className="cancelText" onClick={handleCancel}>Cancel</button>
                                </form>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default EmailSetting;
